import * as React from 'react';
import CustomLink from '../custom-link';
import { cn } from '../../../helpers';

export default function LinkList(props: LinkListProps) {
    const { list, maxLength, className, useIcons = true } = props;
    const items = maxLength ? list.slice(0, maxLength) : list;
    return (
        <ul className={cn('link-list', className)}>
            {items.map((link: LinkListItem) => (
                <li key={link.text} className="link-list__item">
                    {link.type === 'emailAddress' ? (
                        <CustomLink
                            url={link.url}
                            text={link.text}
                            isFullWidth
                            target="_self"
                            linkTheme="alternative"
                        />
                    ) : (<CustomLink url={link.url} text={link.text} hasIcon={useIcons} isFullWidth />)}
                    {link.additionalInfo && <p className="link-list__item_info">{link.additionalInfo}</p>}
                </li>
            ))}
        </ul>
    );
}
